/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1676937600000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Tue Feb 21 2023 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "closeio",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Overview",
          "depth": 0,
          "id": "overview"
        }, {
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Connect to Close",
          "depth": 0,
          "id": "connect-to-close"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Record matching",
          "depth": 1,
          "id": "record-matching"
        }, {
          "value": "Field mapping",
          "depth": 1,
          "id": "field-mapping"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      strong: "strong",
      a: "a",
      img: "img",
      h3: "h3"
    }, _provideComponents(), props.components), {NoCommonErrors, LiveDebugger, SyncAlerts} = _components;
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!NoCommonErrors) _missingMdxReference("NoCommonErrors", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "overview",
        children: "Overview"
      }), "\n", _jsx(_components.p, {
        children: "Your leads and prospects expect you to have the necessary context before engaging with them. You can accomplish this by syncing lead and prospect data from your data warehouse to Close. You no longer need to worry about executives chasing the wrong leads or engaging with warm ones without proper context."
      }), "\n", _jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Sync Type"
            }), _jsx(_components.th, {
              children: "Description"
            }), _jsx(_components.th, {
              children: "Supported Sync Modes"
            }), _jsx(_components.th, {
              children: "API Reference"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Lead"
              })
            }), _jsx(_components.td, {
              children: "Sync data from any source to Leads"
            }), _jsx(_components.td, {
              children: "Upsert, Update"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developer.close.com/resources/leads/",
                children: "Lead docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Contact"
              })
            }), _jsx(_components.td, {
              children: "Sync data from any source to Contacts"
            }), _jsx(_components.td, {
              children: "Upsert, Update"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developer.close.com/resources/contacts/",
                children: "Contact docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Opportunity"
              })
            }), _jsx(_components.td, {
              children: "Sync data from any source to Opportunities"
            }), _jsx(_components.td, {
              children: "Upsert, Update"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developer.close.com/resources/opportunities/",
                children: "Opportunity docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Note Activity"
              })
            }), _jsx(_components.td, {
              children: "Sync data from any source to Note activities"
            }), _jsx(_components.td, {
              children: "Insert, Update"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developer.close.com/resources/activities/note/",
                children: "Note docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Custom Activity"
              })
            }), _jsx(_components.td, {
              children: "Sync data from any source to custom activities"
            }), _jsx(_components.td, {
              children: "Upsert, Update"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developer.close.com/resources/custom-activities/",
                children: "Custom Activities docs"
              })
            })]
          })]
        })]
      }), "\n", _jsx(_components.p, {
        children: "When inserting Note activities, Hightouch creates and attaches new Note activities to the Lead object you specify in your sync configuration."
      }), "\n", _jsxs(_components.p, {
        children: ["For more information about sync modes, refer to the ", _jsx(_components.a, {
          href: "/syncs/types-and-modes#sync-modes",
          children: "sync modes"
        }), " docs."]
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-close",
        children: "Connect to Close"
      }), "\n", _jsxs(_components.p, {
        children: ["Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/destinations?from=docs",
          children: [_jsx(_components.strong, {
            children: "Destinations"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add destination"
        }), " button. Select ", _jsx(_components.strong, {
          children: "Close"
        }), " and click ", _jsx(_components.strong, {
          children: "Continue"
        }), ". You can then authenticate Hightouch to Close with a Close API key."]
      }), "\n", _jsxs(_components.p, {
        children: ["You can generate a Close API Key in your Close account under ", _jsx(_components.a, {
          href: "https://app.close.com/settings/api/",
          children: _jsx(_components.strong, {
            children: "Settings > API Keys"
          })
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-closeio-api-key.png",
          alt: "Close screenshot"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["For more information, refer to ", _jsx(_components.a, {
          href: "https://help.close.com/docs/api-keys",
          children: "Close's docs"
        }), "."]
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've set up your Close destination and have a ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " to pull data from, you can set up your sync configuration to begin syncing data. Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/syncs?from=docs",
          children: [_jsx(_components.strong, {
            children: "Syncs"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add sync"
        }), " button to begin. Then, select the relevant model and the Close destination you want to sync to."]
      }), "\n", _jsx(_components.h3, {
        id: "record-matching",
        children: "Record matching"
      }), "\n", _jsx(_components.p, {
        children: "You can match rows from your model to Close records on any unique property."
      }), "\n", _jsx(_components.p, {
        children: "You must match Contacts by either email or the contact's ID."
      }), "\n", _jsx(_components.h3, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "Use field mapping to sync any model columns to Close's default and custom fields."
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(NoCommonErrors, {}), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
